<div class="heading heading_standard heading_centered">Sign up</div>
<div class="form__desc">
  Already have an account?
  <a routerLink="/auth/sign-in"><strong>Login</strong></a>
</div>

<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  [appScrollToInvalidFieldOnFormSubmit]
  [scrollElement]="ScrollElements.WINDOW"
>
  <div class="fields">
    <div
      class="fields__item fields__item_full"
      [appIfInvalid]="emailFC"
      [validationErrors]="{
        required: 'Please, enter e-mail',
        email: 'Please, provide valid e-mail address',
      }"
    >
      <input
        [formControl]="emailFC"
        type="text"
        placeholder=""
        maxlength="60"
        autocomplete="email"
        id="email"
      />
      <label for="email">E-mail address</label>
      <ng-template [appErrorsHost] />
    </div>

    <app-new-password />

    @if (registrationSuccessful) {
      <p class="success ion-text-center width-100">
        An activation link has been sent to your email!<br />
        Please check your email to confirm your account!
      </p>
    }

    <button
      type="submit"
      class="button button_dark button_standard button_centered"
    >
      Sign up
    </button>

    <app-sign-in-with-google />
    <div
      [appIfInvalid]="termsOfUseFC"
      [validationErrors]="{
        required: 'You must accept the Terms of Use to proceed.',
      }"
    >
      <app-terms-of-use [fc]="termsOfUseFC" />

      <ng-template [appErrorsHost] />
    </div>
  </div>
</form>
